import Component from "../component.abstract"

export default class EngineSticky extends Component {
    menu: HTMLElement;
    constructor(
        private props: unknown,
        element:HTMLElement
    ) { 
        super(props, element)
    }

    mounted(): void {
        if(window.innerWidth > 767) {
            const observer = new IntersectionObserver( 
                ([e]) => { 
                    e.target.classList.toggle('sticky', e.intersectionRatio < 1)
                },
                {rootMargin: "-10px 0px 75px 0px", threshold: [1]}
            );

            observer.observe(this.element)
        }
    }

}